import React, { memo } from 'react';
import { useInventoryDependency } from 'site-modules/shared/components/inventory/inventory-dependency/use-inventory-dependency';

export const SrpSaveSearch = memo(props => {
  const {
    saveSearch: { component: SaveSearchComponent },
  } = useInventoryDependency();

  return <SaveSearchComponent {...props} />;
});

SrpSaveSearch.displayName = 'SrpSaveSearch';
